function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E3D49",
  d: "M3.52917 3C3.23692 3 3 3.23692 3 3.52917V10.4708C3 10.7631 3.23692 11 3.52917 11H10.4708C10.7631 11 11 10.7631 11 10.4708V3.52917C11 3.23692 10.7631 3 10.4708 3H3.52917ZM3.52917 13C3.23692 13 3 13.2369 3 13.5292V20.4708C3 20.7631 3.23692 21 3.52917 21H10.4708C10.7631 21 11 20.7631 11 20.4708V13.5292C11 13.2369 10.7631 13 10.4708 13H3.52917ZM17 13C15.9391 13 14.9217 13.4214 14.1716 14.1716C13.4214 14.9217 13 15.9391 13 17C13 18.0609 13.4214 19.0783 14.1716 19.8284C14.9217 20.5786 15.9391 21 17 21C18.0609 21 19.0783 20.5786 19.8284 19.8284C20.5786 19.0783 21 18.0609 21 17C21 15.9391 20.5786 14.9217 19.8284 14.1716C19.0783 13.4214 18.0609 13 17 13Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E3D49",
  d: "M13.1254 9.51436L16.4258 3.57348C16.8068 2.88767 17.7932 2.88767 18.1742 3.57348L21.4746 9.51436C21.8449 10.1809 21.363 11 20.6005 11H13.9995C13.237 11 12.7551 10.1809 13.1254 9.51436Z"
});

function SvgWidgets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgets);
export default __webpack_public_path__ + "static/media/widgets.93ca511e.svg";
export { ForwardRef as ReactComponent };